import React,{useEffect} from "react";
import bgImage from "../../assets/img/logos.jpg";

const ReturnAndCancelPolicy = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div
      style={{
        ...styles.page,
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div style={styles.container}>
        <div style={{...styles.frame , backgroundColor: "#ffee8c"}}>
          <h2 style={styles.heading}>7-Day Return Policy</h2>
          <p style={styles.text}>
            At Sri Mangalambika Stores, your satisfaction is our priority.
            That’s why we offer a hassle-free 7-day return policy. You can
            return any eligible item within 7 days of receiving your order for a
            return or exchange. We Care About Your Safety, We are happy to take
            back cookware products if they are not used. Please make sure the
            item is new, and all tags, boxes, and packing are not damaged.
            <br />{" "}
            <span style={{ textAlign: "center" }}>
              “ ONE CONDITION PRODUCT SHOULD NOT BE USED “
            </span>
            <br /> No Refund or Replacement for Correct Orders,If we deliver the
            right product, we do not offer return or replacement. So, please
            check all product details carefully before you buy to avoid any
            problems. To Keep Our Products in Good Condition,This policy helps
            us keep all products clean and safe. We thank you for understanding
            and supporting us. If you have any questions, our helpful customer
            service team is always ready to assist you. Thank You for Your
            Trust, We truly appreciate you choosing us and supporting our
            efforts to maintain a safe and healthy community.
          </p>
        </div>

        <div style={{ ...styles.frame, background: "#d1ffbd" }}>
          <h2 style={styles.heading}>Can I Cancel My Order?</h2>
          <p style={styles.text}>
            You can cancel an order within 3 hours of placing the order.
            <br /> • You can simply refuse to accept the parcel at the time of
            delivery as the order will not be returned once delivered.
            <br /> • You can simply Contact our whatsapp or customer care number
            to cancel the order.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    margin: 0,
    padding: "20px",
    fontFamily: "Georgia, serif",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    color: "#3e2f1c",
  },
  container: {
    display: "flex",
    gap: "20px",
    justifyContent: "center",
    padding: "40px 0",
    flexWrap: "wrap",
  },
  frame: {
    flex: "1 1 300px",
    // backgroundColor: "rgba(169, 127, 20, 0.95)",
    border: "3px solid #8b5e3c",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.3)",
    minWidth: "320px",
    maxWidth: "500px",
  },
  heading: {
    fontSize: "26px",
    textAlign: "center",
    marginBottom: "20px",
    borderBottom: "2px dashed #8b5e3c",
    paddingBottom: "10px",
    fontFamily: "Playfair Display, serif",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.7",
    textAlign: "justify",
  },
};

export default ReturnAndCancelPolicy;
